import axiosInstance from '../axiosInterceptor/axiosInstance'

const base = (orgId, streamId) => `v1/orgs/${orgId}/streams/${streamId}/overlays`

// The cards this stream can put on air. The backend decides: a game with no stats behind it —
// its own, or the federation game's when a club game is connected to one — returns none, and so
// does a sport with no stats cards. Each card says whether a side has to be chosen first.
export const getOverlayCards = (orgId, streamId) =>
  axiosInstance.get(`${base(orgId, streamId)}/cards`).then((r) => r.data.cards)

// Put one card on screen. Only one is ever showing, so this replaces whatever was there.
// `team` is 'home' or 'away' and is only meaningful for cards whose requiresTeam is true.
export const showOverlayCard = (orgId, streamId, { overlayType, team = null, quarter = null }) =>
  axiosInstance.put(`${base(orgId, streamId)}/card`, { overlayType, team, quarter })

// Clear whatever is showing. Needs no knowledge of what that was.
export const hideOverlayCard = (orgId, streamId) =>
  axiosInstance.delete(`${base(orgId, streamId)}/card`)

// What the stream is showing right now, asked of the streamer itself. Lives beside the card
// routes rather than under them: the status is the stream's, not one card's.
export const getOverlayStatus = (orgId, streamId) =>
  axiosInstance.get(`v1/orgs/${orgId}/streams/${streamId}/overlay-status`).then((r) => r.data)
